import { DisplayValue } from '@adaptiva/core/common';
import { MenuItem } from '@adaptiva/core/menus';
import { RoutingService } from '@adaptiva/core/routing';
import { Summarizable } from '@adaptiva/core/summary';
import { EditorInput, EJavaClassNames, GlobalEditorService } from '@adaptiva/data-service';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { Params } from '@angular/router';
import { IMetadataObject, MetadataObject } from '../../../../common';

@Pipe({
	name: 'adaCreateChildMenus',
})
export class CreateChildMenusPipe implements PipeTransform {

	protected readonly routingService: RoutingService = inject(RoutingService);

	constructor(private _globalEditorService: GlobalEditorService) {

	}

	public transform(_reference: MetadataObject, _options: DisplayValue<typeof Summarizable>[]): MenuItem<typeof Summarizable>[] {
		return _options?.map((_option: DisplayValue<typeof Summarizable>) => {
			return new MenuItem({
				name: _option.display,
				data: _option.value,
				onSelect: (_menu: MenuItem<typeof Summarizable>) => this._createChild(_reference, _menu.data)
			});
		}) || [];
	}

	private _createChild(_parent: MetadataObject, _type: typeof Summarizable): void {
		const _child: IMetadataObject = _parent.createChild(_type);
		const _params: Params = this.routingService.getRouteParams();

		delete _params['id'];

		switch (_child.javaClassName) {
			case EJavaClassNames.SoftwareRelease:
				_params['group'] = _parent.objectId;
				break;
			case EJavaClassNames.SoftwareReleaseGroup:
			case EJavaClassNames.SoftwarePatch:
				_params['product'] = _parent.objectId;
				break;
		}

		this._globalEditorService.openEditorWithChanges(
			new EditorInput<MetadataObject>(_child.javaClassName, null, _params)
		);
	}

}
